import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState } from 'react';
import ResidenceOriginForm from './form';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { DateTime } from 'luxon';
import { ResidenceOrigin } from 'shell/view-models/personal-data';
import { DisabledFields } from 'shell/view-models/disabled-fields';

interface ResidenceOriginProps {
  onChange: (key: keyof ResidenceOrigin, value: ResidenceOrigin[keyof ResidenceOrigin]) => void;
  onChangeValues: (values: ResidenceOrigin) => void;
  values?: ResidenceOrigin;
  typeRegister?: string;
  disabled?: boolean;
  disabledFields?: DisabledFields<ResidenceOrigin>;
  required?: boolean;
  fromDate?: DateTime | null;
}

function ResidenceOriginComponent({
  onChange,
  onChangeValues,
  typeRegister,
  values,
  disabled = false,
  required = false,
  disabledFields,
  fromDate,
}: ResidenceOriginProps): React.ReactElement {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-subject-attributes-content"
        id="panel-person-subject-attributes-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Provenienza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ResidenceOriginForm
          onChange={onChange}
          disabled={disabled}
          fromDate={fromDate}
          typeRegister={typeRegister}
          values={values}
          disabledFields={disabledFields}
          onChangeValues={onChangeValues}
          required={required}
        />
      </AccordionDetails>
    </Accordion>
  );
}

ResidenceOriginComponent.displayName = 'Residenza/Provenienza component ';

export default memo(ResidenceOriginComponent);
